import script from "./YardageTab.vue?vue&type=script&setup=true&lang=js"
export * from "./YardageTab.vue?vue&type=script&setup=true&lang=js"

import "./YardageTab.vue?vue&type=style&index=0&id=34bd6c65&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34bd6c65"]])

export default __exports__